import { Component, OnDestroy, OnInit, output } from '@angular/core';
import { FormValidatorModule } from '../../shared/form-validator/form-validator.module';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatInput } from '@angular/material/input';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-voucher-client-installations',
  imports: [
    FormValidatorModule,
    FormsModule,
    MatError,
    MatFormField,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    TranslateModule,
    MatInput
  ],
  templateUrl: './voucher-client-installations.component.html',
  styleUrl: './voucher-client-installations.component.scss',
  standalone: true
})
export class VoucherClientInstallationsComponent implements OnInit, OnDestroy {
  formClientInstallationsUpdated = output<FormGroup<FormGroupClientInstallations>>();

  formGroup!: FormGroup<FormGroupClientInstallations>;
  typeList: ('War' | 'Docker')[] = ['War', 'Docker'];

  private subscription = new Subscription();

  ngOnInit(): void {
    this.formGroup = this.createFormGroup();
    const subType$ = this.formGroup.controls.type.valueChanges.subscribe((value) => {
      if (value !== 'Docker') {
        this.formGroup.controls.instances.setValue(undefined);
      }
    });
    this.subscription.add(subType$);

    const subFormChanges$ = this.formGroup.valueChanges.subscribe(() => this.formClientInstallationsUpdated.emit(this.formGroup));
    this.subscription.add(subFormChanges$);

    this.formClientInstallationsUpdated.emit(this.formGroup);
  }

  private createFormGroup(): FormGroup<FormGroupClientInstallations> {
    return new FormGroup<FormGroupClientInstallations>({
      client_id: new FormControl('', {
        validators: Validators.required,
        nonNullable: true
      }),
      type: new FormControl(undefined, {
        validators: Validators.required,
        nonNullable: true
      }),
      instances: new FormControl(undefined, {
        validators: this.instancesValidator(),
        nonNullable: true
      })
    });
  }

  private instancesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (this.formGroup?.controls.type.value !== 'Docker') {
        return null;
      }

      if (!control.value) {
        return { required: 'REQUIRED' };
      }

      return null;
    };
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

export interface FormGroupClientInstallations {
  client_id: FormControl<string>;
  type: FormControl<'War' | 'Docker' | undefined>;
  instances?: FormControl<number | undefined>;
}
